<template>
    <vx-table class="xl:grid-cols-6-auto mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader>
            <div class="lg:pl-6">ID</div>
            <div>Team</div>
            <div>Status</div>
            <div>Created</div>
            <div>Updated</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
